/** Errors and labels produced by hooks. */
export default {
  openFrameProjectFirst:
    "Open the frame in its project before sending the comment.",
  frameAgentUnavailable:
    "This frame's creating agent is not available for direct comments.",
  commentNotReceived:
    "The agent did not receive this comment. Please try again.",
  commentSendFailed: "Couldn’t send comment",
  tryAgain: "Please try again.",
  commentCount: { one: "{count} comment", other: "{count} comments" },
  signInToViewChats: "Sign in to view your chats.",
  offlineNoCachedChats: "You’re offline and no chats are cached.",
  chatNotOffline: "This chat isn’t available offline yet.",
  denkerUnreachable: "Couldn’t reach Denker. Check your connection and retry.",
  inputTargetsLoadFailed: "Couldn’t load chats and sub-agents.",
  chatsLoadFailed: "Couldn’t load chats. Please retry.",
  taskConversationLoadFailed: "Unable to load task conversation status",
  taskConversationUpdateFailed:
    "Unable to update task conversation. Try again.",
  subagentNotTargetable: "This sub-agent can't be targeted",
  branchesLoadFailed: "Failed to load branches",
  agentWaitingTitle: "● Agent waiting — {space}",
} as const;
